import React from "react";
import InfoCard from "../InfoCard/InfoCard";

const ProfileLeft = () => {
  return (
    <div className="Profileside">
      <InfoCard />
    </div>
  );
};

export default ProfileLeft;
